import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class COIRequestForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            input: {
                firstName: userExists ? props.location.state.user.firstname : '',
                lastName: userExists ? props.location.state.user.lastname : '',
                email: userExists ? props.location.state.user.email : '',
                phoneNumber: userExists ? props.location.state.user.phone : '',
                username: userExists ? props.location.state.user.username : '',
                accountNumber: ''
            },
            accounts: [],
            errors: {},
            loading: false
        };

        this.createSelectItems = this.createSelectItems.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showButton = this.showButton.bind(this);
    }

    componentDidMount() {
        axios.get(`${Constants.apiURL}/api/Payment/accounts`, {
            params: {
                username: this.state.user.username,
                isWork: true
            }
        }).then(response => {
            if (response.data) {
                let input = this.state.input;
                input.accountNumber = response.data[0].accountID;
                this.setState(() => ({
                    accounts: response.data,
                    input: input
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    createSelectItems() {
        let items = [];
        items = this.state.accounts.map(function (item) {
            return <option value={item.accountID}>{item.accountID} | {item.accountName}</option>;
        });
        return items;
    }

    handleFormChange(event) {
        console.log(event);
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;

        if (!input["firstName"]) {
            isValid = false;
            errors["firstName"] = "Please enter your first name.";
        }
        if (!input["lastName"]) {
            isValid = false;
            errors["lastName"] = "Please enter your last name.";
        }

        if (!input["phoneNumber"]) {
            isValid = false;
            errors["phoneNumber"] = "Please enter your phone number.";
        }

        if (!input["email"]) {
            isValid = false;
            errors["email"] = "Please enter your email address.";
        }

        if (!input["certHolderName"]) {
            isValid = false;
            errors["certHolderName"] = "Please enter the property name.";
        }

        if (!input["certHolderAddress1"]) {
            isValid = false;
            errors["certHolderAddress1"] = "Please enter the street address.";
        }

        if (!input["certHolderCity"]) {
            isValid = false;
            errors["certHolderCity"] = "Please enter the city.";
        }

        if (!input["certHolderZip"]) {
            isValid = false;
            errors["certHolderZip"] = "Invalid.";
        }
        if (!input["certHolderState"]) {
            isValid = false;
            errors["certHolderState"] = "Invalid.";
        }

        if (!input["entityType"]) {
            isValid = false;
            errors["entityType"] = "Please choose a day.";
        }

        this.setState({
            errors: errors
        });

        return isValid;
    }

    handleSubmit(event) {

        event.preventDefault();
        console.log(this.fileControl);
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        let formData = new FormData();
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }
        formData.append('username', this.state.user.username);

        this.setState({ loading: true });

        axios.post(`${Constants.apiURL}/api/Request/coi`, this.state.input
        ).then(response => {
            console.log(response);
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Request',
                    action: 'COI',
                    label: ''
                });
                alert('Your COI request has been received, and should be processed within two (2) business days. We will reach out with any questions.');
                this.props.history.push({
                    pathname: '/orders',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>
        }
    }

    render() {
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='coiRequest' />
                <Form onSubmit={this.handleSubmit} style={{ padding: 5 }} noValidate>
                    <Row className="form-row-first">
                        <Form.Label style={{ marginBottom: '0px' }} className="form-header">COI Request Form</Form.Label>
                        <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', fontStyle: 'italic' }}>
                            Provide certificate of insurance (COI) request information below. A member of our team will process your request and call with any questions.
                        </Form.Label>

                        <Form.Label className="form-header">Requestor Information</Form.Label>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="accountNumber" >
                                <Form.Label>Account Number</Form.Label>
                                <Form.Select name="accountNumber" onChange={this.handleFormChange}>
                                    {this.createSelectItems()}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formFirstname">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="input" name="firstName" value={this.state.input.firstName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.firstName} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formLastname">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="input" name="lastName" value={this.state.input.lastName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.lastName} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" name="email" value={this.state.input.email} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.email} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Phone number</Form.Label>
                                <Form.Control type="phone" name="phoneNumber" value={this.state.input.phoneNumber} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.phoneNumber} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-first">
                        <Form.Label className="form-header">Certificate Holder Address</Form.Label>
                        <Col md={6} xs={12} >
                            <Form.Group className="mb-3" controlId="certHolderName">
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="input" name="certHolderName" value={this.state.input.certHolderName} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.certHolderName} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary" >
                        <Col md>
                            <Form.Group className="mb-3" controlId="certHolderAddress1">
                                <Form.Label>Street address 1</Form.Label>
                                <Form.Control type="input" name="certHolderAddress1" value={this.state.input.certHolderAddress1} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.certHolderAddress1} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="certHolderAddress2">
                                <Form.Label>Street address 2</Form.Label>
                                <Form.Control type="input" name="certHolderAddress2" value={this.state.input.certHolderAddress2} onChange={this.handleFormChange} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary" >
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="certHolderCity">
                                <Form.Label>City</Form.Label>
                                <Form.Control type="input" name="certHolderCity" value={this.state.input.certHolderCity} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.certHolderCity} />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" controlId="certHolderState">
                                <Form.Label>State</Form.Label>
                                <Form.Select name="certHolderState" value={this.state.input.certHolderState} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.certHolderState} >
                                    <option value=""/>
                                    <option value="AL">AL</option>
                                    <option value="AK">AK</option>
                                    <option value="AS">AS</option>
                                    <option value="AZ">AZ</option>
                                    <option value="AR">AR</option>
                                    <option value="CA">CA</option>
                                    <option value="CO">CO</option>
                                    <option value="CT">CT</option>
                                    <option value="DE">DE</option>
                                    <option value="DC">DC</option>
                                    <option value="FM">FM</option>
                                    <option value="FL">FL</option>
                                    <option value="GA">GA</option>
                                    <option value="GU">GU</option>
                                    <option value="HI">HI</option>
                                    <option value="ID">ID</option>
                                    <option value="IL">IL</option>
                                    <option value="IN">IN</option>
                                    <option value="IA">IA</option>
                                    <option value="KS">KS</option>
                                    <option value="KY">KY</option>
                                    <option value="LA">LA</option>
                                    <option value="ME">ME</option>
                                    <option value="MH">MH</option>
                                    <option value="MD">MD</option>
                                    <option value="MA">MA</option>
                                    <option value="MI">MI</option>
                                    <option value="MN">MN</option>
                                    <option value="MS">MS</option>
                                    <option value="MO">MO</option>
                                    <option value="MT">MT</option>
                                    <option value="NE">NE</option>
                                    <option value="NV">NV</option>
                                    <option value="NH">NH</option>
                                    <option value="NJ">NJ</option>
                                    <option value="NM">NM</option>
                                    <option value="NY">NY</option>
                                    <option value="NC">NC</option>
                                    <option value="ND">ND</option>
                                    <option value="MP">MP</option>
                                    <option value="OH">OH</option>
                                    <option value="OK">OK</option>
                                    <option value="OR">OR</option>
                                    <option value="PW">PW</option>
                                    <option value="PA">PA</option>
                                    <option value="PR">PR</option>
                                    <option value="RI">RI</option>
                                    <option value="SC">SC</option>
                                    <option value="SD">SD</option>
                                    <option value="TN">TN</option>
                                    <option value="TX">TX</option>
                                    <option value="UT">UT</option>
                                    <option value="VT">VT</option>
                                    <option value="VI">VI</option>
                                    <option value="VA">VA</option>
                                    <option value="WA">WA</option>
                                    <option value="WV">WV</option>
                                    <option value="WI">WI</option>
                                    <option value="WY">WY</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" controlId="certHolderZip">
                                <Form.Label>Zip</Form.Label>
                                <Form.Control type="input" name="certHolderZip" value={this.state.input.certHolderZip} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.certHolderZip} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-first">
                        <Form.Label className="form-header">Request Details</Form.Label>
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="entityType">
                                <Form.Label>Entity</Form.Label>
                                <Form.Select name="entityType" value={this.state.input.entityType} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.entityType} >
                                    <option key='blankChoice' hidden value="">Please select one...</option>
                                    <option value="Boland">Boland</option>
                                    <option value="Parklawn">Parklawn</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Form.Group className="mb-3" controlId="formInsuranceRequirements">
                            <Form.Label>Insurance requirements</Form.Label>
                            <Form.Control as="textarea" rows={3} name="insuranceRequirements" value={this.state.input.insuranceRequirements} onChange={this.handleFormChange} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formAdditionalInformation">
                            <Form.Label>Additional information</Form.Label>
                            <Form.Control as="textarea" rows={3} name="additionalInformation" value={this.state.input.additionalInformation} onChange={this.handleFormChange} />
                        </Form.Group>
                    </Row>
                    {this.showButton()}
                </Form>
            </div>
        );
    }
}

export default COIRequestForm;